import React from "react";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { QRCodeCanvas } from "qrcode.react";
import { useSelector } from "react-redux";
import config, { frontendUrl } from "../../../config";

const BusinessQrCodeProfile = () => {
  const userData = useSelector((state) => state.user_data);

  console.log(userData, "vbhdfvbdfjhvb ");
  function convertPngToJpg(pngFileUrl, callback, quality = 0.92) {
    const img = new Image();
    img.crossOrigin = "Anonymous";

    img.onload = function () {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0);

      const jpgDataUrl = canvas.toDataURL("image/jpeg", quality);
      callback(jpgDataUrl);
    };

    img.onerror = function () {
      console.error("Failed to load image:", pngFileUrl);
      callback(pngFileUrl);
    };

    img.src =
      pngFileUrl +
      (pngFileUrl.indexOf("?") === -1 ? "?" : "&") +
      "t=" +
      new Date().getTime();
  }

  const downloadAsJpeg = () => {
    const element = document.querySelector("#capture");
    if (!element) {
      console.error("Element with id 'capture' not found");
      return;
    }

    html2canvas(element, {
      scale: 3,
      useCORS: true,
      allowTaint: true,
      logging: true,
    })
      .then((canvas) => {
        const images = element.querySelectorAll("img");
        let promises = [];

        images.forEach((img) => {
          if (img.src.includes("png")) {
            promises.push(
              new Promise((resolve) => {
                convertPngToJpg(img.src, function (jpgDataUrl) {
                  img.src = jpgDataUrl;
                  resolve();
                });
              })
            );
          }
        });

        Promise.all(promises)
          .then(() => {
            let link = document.createElement("a");
            link.download = "business_card.jpg";
            link.href = canvas.toDataURL("image/jpeg", 1.0);
            link.click();
          })
          .catch((error) => {
            console.error("Error converting images:", error);
            let link = document.createElement("a");
            link.download = "business_card.jpg";
            link.href = canvas.toDataURL("image/jpeg", 1.0);
            link.click();
          });
      })
      .catch((error) => {
        console.error("Error generating canvas:", error);
        alert("Failed to generate image. Please try again.");
      });
  };

  const downloadAsPdf = () => {
    html2canvas(document.querySelector("#capture"), {
      scale: 3,
      useCORS: true,
    }).then((canvas) => {
      const images = document.querySelectorAll("img");
      let promises = [];

      images.forEach((img) => {
        if (img.src.includes("png")) {
          promises.push(
            new Promise((resolve) => {
              convertPngToJpg(img.src, function (jpgDataUrl) {
                img.src = jpgDataUrl;
                resolve();
              });
            })
          );
        }
      });

      Promise.all(promises).then(() => {
        const pdf = new jsPDF("portrait", "in", [5, 7]);
        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        pdf.addImage(imgData, "JPEG", 0, 0, 5, 7);
        pdf.save("business_card.pdf");
      });
    });
  };

  const businessName = `${userData?.businessUniqueName}`;
  const fullBusinessUrl = `${frontendUrl}/${businessName}`;

  return (
    <div className="pt-3">
      <h1 className="qr-widget-business-title">
        {/* {userData?.fullName} QR Sticker */}
        {userData?.businessName} QR Sticker
      </h1>
      <p className="qr-widget-business-para">
        This QR card is a ready-to-print appointment sticker designed to help you drive more direct bookings through your BookYarra business profile
      </p>
      <div className="card-5x7" id="capture">
        <div>
          <div className="qr-widget-business-logo">
            <img src={userData?.businessLogo ? (config?.Imageurl + userData?.businessLogo) : "https://mock.sonarpos.com/static/media/noimage.4ab3885dec12ad76c627.png"} alt="Logo" />
          </div>

          {/* <h2 className="qr-widget-business-name">{userData?.fullName}</h2> */}
          <h2 className="qr-widget-business-name">{userData?.businessName}</h2>
          <p className="qr-widget-business-category">
            {userData?.businessTypeName}
          </p>

          <div className="divider"></div>

          <p className="qr-widget-business-visit">
           VISIT OUR BUSINESS PROFILE ON THE BOOKYARRA PORTAL
          </p>

          <div className="divider"></div>
        </div>

        <div>
          <h4 className="qr-widget-business-scan-here">SCAN HERE</h4>
          <div className="qr-widget-qr-code qr-widget-qr-code-background">
            <QRCodeCanvas
              value={fullBusinessUrl}
              size={190}
              level="H"
              includeMargin={true}
              bgColor="#ffffff"
              fgColor="#000000"
              style={{ margin: "10px 0px 0px 0px", borderRadius: "20px" }}
            />
          </div>
          <h3 className="qr-widget-business-book-app">BOOK YOUR APPOINTMENT</h3>
          <div className="divider"></div>
        </div>

        <div>
          <div className="qr-widget-foo-portal">
            <div className="qr-widget-foo-left">
              <img
                className="qr-widget-portal-logo"
                src="assets/img/BookYarra_logo_black.png"
                alt="Powered By"
              />
              {/* <img src={config?.Imageurl + userData?.businessLogo} alt="Logo" style={{width:"85px", height:"85px", objectFit:"contain", display:"block", margin:"0px 10px", borderRadius:"50%"}} /> */}
            </div>
            <div className="qr-widget-foo-right">
              <p className="qr-widget-business-powered-by">Powered By</p>
              <p className="qr-widget-business-pb-BookYarra">BookYarra</p>
              <p className="qr-widget-business-pb-website">www.bookyarra.com</p>
            </div>
          </div>

          <div className="divider"></div>

          <p className="qr-widget-business-pb-footer-content">
            BOOK APPOINTMENTS WITH BOOKYARRA ANYTIME, ANYWHERE
          </p>
        </div>
      </div>

      <div className="qr-widget-buttons-wrapper">
        <button className="btn btn-primary m-2" onClick={downloadAsJpeg}>
          Download as JPEG
        </button>
        <button className="btn btn-success m-2" onClick={downloadAsPdf}>
          Download as PDF
        </button>
      </div>
      <p className="qr-widget-business-para">
        Simply print and place it at your storefront, counter, mirror, or
        waiting area. When customers scan the code, 
        they will be taken directly to your online profile, where they can instantly book appointments.
      </p>

      <style>{`
          .card-5x7 {
            width: 100%;
            max-width: 5in;
            min-height: 7in;
            height: auto;
            background: white;
            padding: 20px 15px;
            margin: 20px auto;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
            position: relative;
            box-sizing: border-box;
            text-align: center;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            background: #fff;
          }

          .divider {
            border-top: 1px solid #ccc;
            margin: 8px 0;
          }
          .qr-widget-business-logo img {
            width: 75px;
            height: 75px;
            object-fit: contain;
            display: block;
            margin: 0 auto 8px;
            border-radius : 50%;
          }
          .qr-widget-qr-code img {
            width: 220px;
            height: 220px;
            max-width: 100%;
            object-fit: cover;
            padding:10px;
            border-radius:20px;
          }

          .qr-widget-font-family-popins{
            font-family: 'Poppins', sans-serif;
          }

          .qr-widget-background{
            width : 100%;
            max-width : 210px;
            height : auto;
            object-fit : contain;
            display: block;
            margin : 10px auto 10px;
            background : #fff;
            border-radius : 20px;
          }

          .qr-widget-buttons-wrapper {
            margin-top: 20px;
            text-align: center;
          }
     
          .qr-widget-business-name{
            font-weight: 700 !important;
            font-size: 24px;
          }
          
          .qr-widget-business-category{
            font-weight: 600 !important;
            font-size: 16px;
          }
          
          .qr-widget-business-visit{
            font-weight: 600 !important;
            font-size: 13px;
            padding-top: 5px;
            line-height: 1.4;
          }
          
          .qr-widget-business-scan-here{
            font-weight: 700 !important;
            font-size: 26px;
            line-height: 1.2;
            padding:10px 0px 0px 0px;
          }
          .qr-widget-business-book-app{
            font-weight: 700 !important;
            font-size: 24px;
            line-height: 1.2;
            padding:10px 0px 10px 0px;
          }
          .qr-widget-business-powered-by{
            font-weight: 500 !important;
            font-size: 13px;
            line-height: 1.2;
            text-align: left;
          }
          
          .qr-widget-business-pb-BookYarra{
            font-weight: 700 !important;
            font-size: 16px;
            line-height: 1.2;
            text-align: left;
          }
          
          .qr-widget-business-pb-footer-content{
            font-weight: 500 !important;
            font-size: 13px;
            line-height: 1.4;
            text-align: center;
          }
          
          .qr-widget-business-pb-website{
            font-weight: 500 !important;
            font-size: 13px;
            line-height: 1.2;
            text-align: left;
          }
          .qr-widget-portal-logo{
            width: 100%;
            max-width: 200px;
            height: auto;
            object-fit: contain;
            display: block;
            margin: 0px auto;
          }
          
          .qr-widget-foo-portal{
            display:flex;
            align-items: center;
            gap : 10px;
            justify-content : center;
            flex-wrap: wrap;
          }
          .qr-widget-foo-right{
            padding-top:5px;
          }
          .qr-widget-business-title{
            font-weight: 700 !important;
            font-size: 24px;
            text-align:center;
            padding-top:20px;
          }
          .qr-widget-business-para{
            display: block;          
            width: 100%;
            max-width: 7in;
            margin: 0 auto;                
            font-weight: 500;
            font-size: 15px;
            text-align: center; 
            white-space: normal;
            overflow-wrap: break-word;
            word-wrap: break-word;
            padding: 0 15px;
          }
        `}</style>
    </div>
  );
};

export default BusinessQrCodeProfile;
